/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { useLocation } from 'react-router-dom';

export default function useToken(): string | null {
	const params = new URLSearchParams(useLocation().search);
	const token = params.get('token');

	return token ?? null;
}
